<template>
  <div>

    <center>
      <h2 class="ui inverted huge header">
        {{ localisation.login.title }}
        <div class="sub header">{{ localisation.studyName }}</div>
      </h2>
    </center>

    <div class="ui top attached inverted segment">

      <form class="ui form" @submit.prevent="attemptLogin" novalidate>

        <div class="field">
          <label>{{ localisation.login.email }}</label>
          <input type="email" placeholder="user@mail.com" v-model="emailField">
        </div>

        <div class="field">
          <label>{{ localisation.login.password }}</label>
          <input type="password" v-model="passwordField">
        </div>

        <error-messages v-if="hasError" :errors="errorMessages"/>

        <center>
          <button type="submit" class="ui tertiary button">
            <i class="envelope icon"/>
            {{ localisation.login.email }}
          </button>
        </center>
      </form>
    </div>

    <div class="ui bottom inverted tertiary attached message">
      <div class="ui small inverted header">{{ localisation.login.downloadInstructionTitle }}</div>
      <label v-html="localisation.login.downloadInstructionBody" />
    </div>

  </div>
</template>

<script>

import Vue from 'vue'
import ErrorMessages from '../components/ErrorMessages'
import { mapActions } from 'vuex'
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'Login',
  components: {
    ErrorMessages
  },
  data () {
    return {
      emailField: null,
      passwordField: null,
      hasError: false,
      errorMessages: []
    }
  },
  validations: {
    emailField: { required, email },
    passwordField: { required }
  },
  computed: {
    signInField () {
      return {
        'appId': 'square-study', // TODO: NOT HARDCODE THIS!
        // 'appId': this.chosenStudy.studyName,
        'email': this.emailField,
        'password': this.passwordField
      }
    }
  },
  methods: {
    ...mapActions(['checkStudyConsent', 'checkStudyIdentifier', 'fetchQnBuddyBotId']),

    attemptLogin () {
      this.hasError = false
      this.errorMessages = []

      if (this.$v.$invalid) {
        this.hasError = true
        if (this.$v.emailField.$invalid) {
          this.errorMessages.push('invalidEmail')
        }
        if (this.$v.passwordField.$invalid) {
          this.errorMessages.push('emptyPassword')
        }
      } else {
        this.$http.post(process.env.VUE_APP_API_EMAIL_AUTH, this.signInField).then((response) => {
          let userAuthToken = {}
          userAuthToken[this.chosenStudy.studyName] = response.body.result.authenticationToken

          this.updateUserParameters({
            userId: response.body.result.user.id,
            userAuthToken: userAuthToken
          }).then(() => {
            Promise.all([this.checkStudyConsent(), this.checkStudyIdentifier(), this.fetchQnBuddyBotId()]).then(() => {
              if (this.studyConsent) {
                this.$router.push({ name: 'Manage' })
              } else {
                this.$router.push({ name: 'RequestConsent' })
              }
            }, (error) => {
              this.hasError = true
              this.errorMessages.push('genericMessage')
              console.log(error)
            })
          })
        }, (error) => {
          this.hasError = true
          if (error.status === 401) {
            this.errorMessages.push('invalidCredentials')
          } else {
            this.errorMessages.push('genericMessage')
            Vue.Rollbar.error('Error during login:', error)
          }
        })
      }
    }
  }
}

</script>

<style scoped>
label {
  color: white !important
}
</style>
